<template>
  <div class="flex flex-wrap mb-4">
    <label
      v-if="$slots.default"
      class="w-1/4"
      :for="name"
    >
      <slot />
    </label>
    <div class="flex-grow">
      <input
        :id="name"
        ref="file"
        class="rounded w-full text-sm p-2 focus:bg-gray-50 outline-none"
        type="file"
        @change="handleFileUpload($event)"
      >
      <ErrorRow
        :error-fields="errorFields"
        :name="name"
        :submitted="submitted"
      />
    </div>
    <ErrorIcon
      :error-fields="errorFields"
      :name="name"
      :submitted="submitted"
    />
  </div>
</template>

<script setup>
import { ref,watch } from 'vue'

import ErrorIcon from "./ErrorIcon.vue";
import ErrorRow from "./ErrorRow.vue";

const props = defineProps({
  errorFields: {
    type: Object,
    required: true
  },
  submitted: {
    type: Boolean,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: File,
    default: null
  }
})

const emit = defineEmits(['update:modelValue'])
const file = ref(null)

//resetto input quando da fuori resetto la form
watch(() => props.modelValue, (value) => {
  if(!value) {
    file.value.value = null
  }
})

const handleFileUpload = (event) => {
  const target = event.target
  if (target && target.files) {
    emit('update:modelValue', target.files[0])
  }
}
</script>